import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import CheckboxGrid from '@/components/ui/CheckboxGrid';
import {
  TYPE_VOIE_ACCES_OPTIONS,
  TYPE_PORTAIL_OPTIONS,
  FORME_TERRAIN_OPTIONS,
  RELIEF_TERRAIN_OPTIONS,
  GEODESIE_OPTIONS,
  CLOTURE_OPTIONS,
  QUALITE_ENTRETIEN_TERRAIN_OPTIONS,
  NIVEAU_ENCOMBREMENT_OPTIONS,
  PARTIE_NON_BATIE_OPTIONS,
  APPRECIATION_4_OPTIONS,
  APPRECIATION_5_OPTIONS,
} from '@/constants/enums';

export default function SectionTerrain({ data, onChange, formatRapport }) {
  const val = (field) => data?.[field] ?? '';
  const arrVal = (field) => data?.[field] ?? [];
  const handleChange = (field) => (e) => onChange(field, e.target.value);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Select
          label="Voie d'accès"
          name="acces_voie"
          value={val('acces_voie')}
          options={TYPE_VOIE_ACCES_OPTIONS}
          onChange={handleChange('acces_voie')}
        />
        <Select
          label="Portail"
          name="portail"
          value={val('portail')}
          options={TYPE_PORTAIL_OPTIONS}
          onChange={handleChange('portail')}
        />
        <Select
          label="Forme"
          name="forme"
          value={val('forme')}
          options={FORME_TERRAIN_OPTIONS}
          onChange={handleChange('forme')}
        />
        <Select
          label="Relief"
          name="relief"
          value={val('relief')}
          options={RELIEF_TERRAIN_OPTIONS}
          onChange={handleChange('relief')}
        />
        <Select
          label="Exposition / Orientation"
          name="exposition"
          value={val('exposition')}
          options={GEODESIE_OPTIONS}
          onChange={handleChange('exposition')}
        />
        <Select
          label="Clôture"
          name="cloture"
          value={val('cloture')}
          options={CLOTURE_OPTIONS}
          onChange={handleChange('cloture')}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!data?.verdure}
            onChange={(e) => onChange('verdure', e.target.checked)}
            className="rounded border-slate-300"
          />
          Engazonné
        </label>
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!data?.arbore}
            onChange={(e) => onChange('arbore', e.target.checked)}
            className="rounded border-slate-300"
          />
          Arboré
        </label>
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!data?.amenagements_paysagers}
            onChange={(e) => onChange('amenagements_paysagers', e.target.checked)}
            className="rounded border-slate-300"
          />
          Aménagements paysagers
        </label>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Select
          label="Entretien"
          name="entretien"
          value={val('entretien')}
          options={QUALITE_ENTRETIEN_TERRAIN_OPTIONS}
          onChange={handleChange('entretien')}
        />
        <Select
          label="Implantation sur le terrain"
          name="emplacement_construction"
          value={val('emplacement_construction')}
          options={GEODESIE_OPTIONS}
          onChange={handleChange('emplacement_construction')}
        />
        <Input
          label="Cheminement d'accès"
          name="cheminement"
          value={val('cheminement')}
          onChange={handleChange('cheminement')}
        />
        <Select
          label="Encombrement"
          name="encombrement"
          value={val('encombrement')}
          options={NIVEAU_ENCOMBREMENT_OPTIONS}
          onChange={handleChange('encombrement')}
        />
        {formatRapport === 'standard' && (
          <Select
            label="Qualité des aménagements"
            name="qualite_amenagements"
            value={val('qualite_amenagements')}
            options={APPRECIATION_4_OPTIONS}
            onChange={handleChange('qualite_amenagements')}
          />
        )}
        {formatRapport === 'bcg' && (
          <Select
            label="Qualité des aménagements (BCG)"
            name="qualite_amenagements_bcg"
            value={val('qualite_amenagements_bcg')}
            options={APPRECIATION_5_OPTIONS}
            onChange={handleChange('qualite_amenagements_bcg')}
          />
        )}
      </div>

      <div>
        <CheckboxGrid
          label="Parties non bâties"
          name="parties_non_baties"
          value={arrVal('parties_non_baties')}
          options={PARTIE_NON_BATIE_OPTIONS}
          onChange={(value) => onChange('parties_non_baties', value)}
        />
      </div>

      <div className="space-y-4">
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!data?.servitudes_privees}
            onChange={(e) => onChange('servitudes_privees', e.target.checked)}
            className="rounded border-slate-300"
          />
          Servitudes privées
        </label>

        {data?.servitudes_privees && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pl-6">
            <Input
              label="Nature de la servitude"
              name="servitude_nature"
              value={val('servitude_nature')}
              onChange={handleChange('servitude_nature')}
            />
            <Input
              label="Fonds dominant"
              name="servitude_fonds_dominant"
              value={val('servitude_fonds_dominant')}
              onChange={handleChange('servitude_fonds_dominant')}
            />
            <Input
              label="Fonds servant"
              name="servitude_fonds_servant"
              value={val('servitude_fonds_servant')}
              onChange={handleChange('servitude_fonds_servant')}
            />
            <Input
              label="Emprise"
              name="servitude_emprise"
              value={val('servitude_emprise')}
              onChange={handleChange('servitude_emprise')}
            />
            <Input
              label="Impact"
              name="servitude_impact"
              value={val('servitude_impact')}
              onChange={handleChange('servitude_impact')}
            />
          </div>
        )}
      </div>
    </div>
  );
}
